/**
 * Global-search parity (D5). The flat SearchableLightbox searched ALL options
 * at once; a per-folder-only search in the cascade would be a regression. When
 * the root search box has a term, RootPanel replaces the sectioned view with a
 * FLAT list of every matching leaf across the whole tree (dataset fields, anno
 * sibling rows, and sub-theme leaves nested inside Thematics/Attributes).
 *
 * Matching semantics intentionally mirror SearchableLightbox.filterOptions:
 * case-insensitive substring on a leaf's `display` and `desc`.
 */

const matches = (leafContent, term) => {
  const display = (leafContent.display || "").toLowerCase();
  const desc = (leafContent.desc || "").toLowerCase();
  return display.includes(term) || desc.includes(term);
};

const collectLeaves = (rows, out) => {
  for (const row of rows || []) {
    if (row.type === "folder") {
      collectLeaves(row.children, out);
    } else if (row.type === "leaf") {
      out.push(row);
    }
  }
};

/**
 * @param {Array} sections  the buildCascadeTree() output
 * @param {string} rawTerm  the current search string
 * @returns {Array} matching leaf rows (each a { type:'leaf', content, option });
 *          empty term returns [] (caller renders the sectioned view instead).
 */
export const flattenForSearch = (sections = [], rawTerm = "") => {
  const term = (rawTerm || "").trim().toLowerCase();
  if (!term) return [];

  const allLeaves = [];
  for (const section of sections) {
    collectLeaves(section.rows, allLeaves);
  }

  // De-dupe by leaf value (a sub-theme appears only once here anyway, but guard
  // against any option that is both a folder child and a sibling).
  const seen = new Set();
  const result = [];
  for (const leaf of allLeaves) {
    if (!matches(leaf.content, term)) continue;
    if (seen.has(leaf.key)) continue;
    seen.add(leaf.key);
    result.push(leaf);
  }
  return result;
};
